/**
 * The run history stat row (mission 6 WP09 T051; FR-019, NFR-005; B.3; sheet
 * 10 callout 2; research §1.7, §1.20; T1).
 *
 * Balance and Reserved from `['credits']`, through the same factory as the
 * top-bar chip, so the figure is the chip's (Balance is `balance`, never
 * `balance + reserved`) and one navigation reads the balance once. Counts are
 * mono; loading shows the stat card's skeleton and a failed read shows "—".
 */
import { useQuery } from '@tanstack/react-query'

import { StatCard } from '@/components/trellis/StatCard'
import { count } from '@/lib/format'
import { creditsQuery } from '@/lib/queries'

export function HistoryStats() {
  const credits = useQuery(creditsQuery())
  const loading = credits.isPending
  const value = (n: number | undefined) => (n === undefined ? '—' : count(n))
  return (
    <div data-history-stats="" className="grid max-w-md grid-cols-2 gap-4">
      <StatCard label="Balance" value={value(credits.data?.balance)} mono loading={loading} />
      <StatCard label="Reserved" value={value(credits.data?.reserved)} mono loading={loading} />
    </div>
  )
}
